import { getResponseParseService } from 'services/ResponseParseService'
import { makeSpinRequest } from 'services/ServerService'
import { signal } from 'services/SignalsService'

const name = 'REQUEST-RESPIN'

async function execute() {
  signal.dispatch(`SOUND:spin-btn:${game.models.ModeModel.turbo}`)

  const lines = game.models.SpinModel.get().lines
  const action = game.models.ResponseDataModel.get().action
  const response = await makeSpinRequest({
    action: action,
    token: game.models.GameModel.token,
    params: {
      bet: game.models.BetModel.getValue() / lines,
      lines,
    },
    platform: game.models.GameModel.platform,
    m: game.models.GameModel.m,
  })

  if (!game.models.GameModel.requestAgainAllowed) {
    if (response && response.status.ok) {
      getResponseParseService().parse(response)
    }
  }
}

export function getRequestRespinAction() {
  return {
    name,
    execute,
  }
}
